// Traffic Snapshot logo mark — the rising-line glyph with the pink Sked
// heart coming off the top. Ported verbatim from the 2026-04 design
// handoff (logo-for-traffic-snapshot/project/Traffic Snapshot Homepage.html
// → #m-primary symbol).

import type { SVGProps } from "react";

export function SkedMark(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 120 120" {...props}>
      <rect x="4" y="4" width="112" height="112" rx="26" fill="#FEE7F2" />
      <path
        d="M24 94 Q 24 68 50 68 T 84 46"
        stroke="#4F31FF"
        strokeWidth="7"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="24" cy="94" r="10" fill="none" stroke="#9583FF" strokeWidth="2" />
      <circle cx="24" cy="94" r="6" fill="#4F31FF" />
      <g transform="translate(74.8,14.28) scale(0.32)">
        <path
          d="M 60 96 C 100 70, 100 34, 78 34 C 70 34, 64 42, 60 50 C 56 42, 50 34, 42 34 C 20 34, 20 70, 60 96 Z"
          fill="#ED207C"
        />
      </g>
    </svg>
  );
}

// Sked Social wordmark square — the monochrome "S" block lifted from the
// Sked brand sheet, used in the marketing marquee + the About-Sked ribbon.
export function SkedBlock(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 326 326" {...props}>
      <path
        d="M263.8,326H62.2A62.4,62.4,0,0,1,0,263.8V62.2A62.4,62.4,0,0,1,62.2,0H263.8A62.4,62.4,0,0,1,326,62.2V263.8A62.4,62.4,0,0,1,263.8,326Z"
        fill="#ED207C"
      />
      <path
        d="M285.7,76.5h0a1.45,1.45,0,0,0-.2-.7h0v-.1c0-.1-.1-.1-.1-.2s-.1-.1-.1-.2a.1.1,0,0,0-.1-.1l-.1-.1L285,75l-.1-.1-.1-.1c-.1,0-.1-.1-.2-.1a.35.35,0,0,0-.2-.1c-.1,0-.1-.1-.2-.1h-.1c-.2-.1-.4-.1-.6-.2H140.2a2.73,2.73,0,0,0-1.9.8l-28,31.1v.1a2.19,2.19,0,0,0-.3.5.1.1,0,0,1-.1.1c-.1.2-.1.4-.2.6v40.4H72.6a2.19,2.19,0,0,0-1.7.7L41.1,176.8a2.33,2.33,0,0,0-.6,2.6v69.9a2.48,2.48,0,0,0,2.5,2.5H183a3.26,3.26,0,0,0,1.4-.4l.1-.1c.1-.1.2-.1.3-.2h0l28.3-29.7a2.84,2.84,0,0,0,.7-1.7V181.2h38.6c.1,0,.1,0,.2-.1s.2,0,.2-.1.1-.1.2-.1.1-.1.2-.1.1-.1.2-.1.1-.1.2-.1l31.1-29.7a2.5,2.5,0,0,0,.8-1.8l.2-72.2Zm-36.4,99.6H185.4V110.3h64v32.3ZM114.7,150.3v-40h65.8v65.8H114.7V150.3Zm136.2-45H188.8l24.7-26.1h63.6ZM141.3,79.2h65.2l-24.7,26.1h-64ZM73.6,152.8h36.1v23.3H49.1ZM45.5,181.1h64.2v65.7H45.5V181.1Zm69.2,0h65.8v65.7H114.7V181.1Zm94,37.5-23.3,24.5v-62h23.3Zm45.7-45.9v-26l.1-37.9,26.2-26.1-.2,65.1Z"
        fill="#fff"
      />
    </svg>
  );
}
